import * as tslib_1 from "tslib";
import mailRowRouteHandler from './mailRowRouteHandler';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { lazySetItemIdToScrollTo } from 'owa-mail-reading-pane-store';
import { lazyClearPendingNavigation, lazyClosePreview, lazyPreviewFromNavigation, } from 'owa-preview-pane-store';
import { lazyForceCloseSxS, lazyOnPendingNavigation } from 'owa-sxs-store';
export function mailSxSNavigationRoutehandler(parameters) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var onPendingNavigation;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    mailRowRouteHandler(parameters);
                    if (!isAttachmentFeatureEnabled('doc-SxS-refactor')) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyOnPendingNavigation.import()];
                case 1:
                    onPendingNavigation = _a.sent();
                    onPendingNavigation(parameters.attachmentId);
                    return [3 /*break*/, 5];
                case 2: return [4 /*yield*/, lazyPreviewFromNavigation.importAndExecute(parameters.attachmentId)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, lazySetItemIdToScrollTo.importAndExecute(parameters.itemId)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
}
export function mailSxSCleanupRouteHandler(oldRoute, oldParameters, newRoute, newParameters) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var stillInSxS, forceCloseSxS;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    stillInSxS = !!newRoute && newRoute.some(function (value) { return value == 'sxs'; });
                    if (!isAttachmentFeatureEnabled('doc-SxS-refactor')) return [3 /*break*/, 3];
                    if (!!stillInSxS) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyForceCloseSxS.import()];
                case 1:
                    forceCloseSxS = _a.sent();
                    forceCloseSxS('browserNavigation');
                    _a.label = 2;
                case 2: return [3 /*break*/, 6];
                case 3: return [4 /*yield*/, lazyClearPendingNavigation.importAndExecute()];
                case 4:
                    _a.sent();
                    if (!!stillInSxS) return [3 /*break*/, 6];
                    return [4 /*yield*/, lazyClosePreview.importAndExecute('browserNavigation')];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/, false];
            }
        });
    });
}
//# sourceMappingURL=mailSxSRouteHandler.js.map